import styled from "styled-components";
import { panelSpacing, Scrollable } from "../../../../../common/styles";

export const ProgramParticipantsContainer = styled.div`
  @media (max-width: 640px) {
    overflow-y: scroll;
    height: calc(100vh - 145px);
  }
`;
export const MyTeamContainers = styled.div`
  @media (max-width: 640px) {
    overflow-y: scroll;
  }
`;

export const PillContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: ${(props) => (props.meetings ? "" : `${panelSpacing}px`)};
  justify-content: ${(props) => (props.meetings ? "center" : "space-between")};

  @media (max-width: 1366px) {
    flex-wrap: wrap;
    row-gap: 10px;
  }
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const SearchBoxContainer = styled.div`
  position: relative;
  width: 300px;

  @media (max-width: 1366px) {
    max-width: 300px;
    width: 100%;
  }
  @media (max-width: 991px) {
    order: 0;
    max-width: 400px;
  }
  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 9;
`;

export const ButtonWraper = styled.div`
  display: none;
`;

export const ParticipantButtonsRow = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 640px) {
    margin-bottom: 10px;
  }
`;

export const SearchBoxRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const ButtonText = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
export const BackButton = styled.div`
  border-radius: 5px;
  border: 1px solid #302f2f;
  display: flex;
  gap: 12px;
  width: 100px;
  height: 40px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ExportContainer = styled.div`
  position: relative;
`;

export const ExportOptions = styled.div`
  position: absolute;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  width: 240px;
  right: 0;
  z-index: 11;
`;
export const ExportOption = styled.button`
  background: transparent;
  border: none;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid #ddd;
  width: 100%;
  text-align: left;
`;
export const Export = styled.button`
  height: 44px;
  padding: 5px 8px;
  display: flex;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #ededed;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

export const ExportText = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
export const ParticipantsOuterContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  margin: 0 12px;
  ${Scrollable}
  height: calc(100vh - 150px);
`;

export const FilterContainer = styled.div`
  min-height: 100%;
  height: 100%;
`;
